"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var groupBy = exports.groupBy = function groupBy(rootTable, manyTable, foreignKeyName) {
  var rootByMany = {};
  for (var rootTableRecordId in rootTable) {
    if (rootTable.hasOwnProperty(rootTableRecordId)) {
      rootByMany[rootTableRecordId] = [];
    }
  }
  for (var manyTableRecordId in manyTable) {
    if (manyTable.hasOwnProperty(manyTableRecordId)) {
      var foreignKey = manyTable[manyTableRecordId][foreignKeyName];
      if (rootTable.hasOwnProperty(foreignKey)) {
        rootByMany[foreignKey].push(manyTableRecordId);
      }
    }
  }
  return rootByMany;
};
var where = exports.where = function where(indexObject, fieldName, id) {
  var results = [];
  for (var objectId in indexObject) {
    if (indexObject.hasOwnProperty(objectId) && indexObject[objectId][fieldName] === id) {
      results.push(indexObject[objectId]);
    }
  }
  return results;
};
var normalizedWhere = exports.normalizedWhere = function normalizedWhere(indexObject, fieldName, id) {
  var results = {};
  for (var objectId in indexObject) {
    if (indexObject.hasOwnProperty(objectId) && indexObject[objectId][fieldName] === id) {
      results[objectId] = indexObject[objectId];
    }
  }
  return results;
};
var idsWhere = exports.idsWhere = function idsWhere(indexObject, fieldName, id) {
  return where(indexObject, fieldName, id).map(function (_ref) {
    var id = _ref.id;
    return id;
  });
};
var deleteWhere = exports.deleteWhere = function deleteWhere(indexObject, fieldName, values) {
  var results = _extends({}, indexObject);
  if (!Array.isArray(values)) {
    values = [values];
  }
  for (var objectId in results) {
    if (results.hasOwnProperty(objectId) && values.indexOf(results[objectId][fieldName]) > -1) {
      delete results[objectId];
    }
  }
  return results;
};